import { render, staticRenderFns } from "./compare.vue?vue&type=template&id=e45c235a&"
import script from "./compare.vue?vue&type=script&lang=ts&"
export * from "./compare.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports